import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {ROUTE_ADD_DIGI_DOCUMENT_SIGNER_CONFIGURATION,
  ROUTE_DIGI_DOCUMENT_SIGNER_CONFIGURATION,
  ROUTE_EDIT_DIGI_DOCUMENT_SIGNER_CONFIGURATION,
  ROUTE_VIEW_DIGI_DOCUMENT_SIGNER_CONFIGURATION} from '../../RoutePathConstant';

const DigiDocumentSignerConfiguration = lazy(() =>
  import('../../../screens/DigiDocumentSignerConfiguration')
    .then(module => ({default: module.DigiDocumentSignerConfiguration})));

const AddDigiDocumentSignerConfiguration = lazy(() =>
  import('../../../screens/DigiDocumentSignerConfiguration')
    .then(module => ({default: module.AddDigiDocumentSignerConfiguration})));

const EditDigiDocumentSignerConfiguration = lazy(() =>
  import('../../../screens/DigiDocumentSignerConfiguration')
    .then(module => ({default: module.EditDigiDocumentSignerConfiguration})));

const ViewDigiDocumentSignerConfiguration = lazy(() =>
  import('../../../screens/DigiDocumentSignerConfiguration')
    .then(module => ({default: module.ViewDigiDocumentSignerConfiguration})));

const DigiDocumentSignerConfigurationNavigation = [
  {
    path: ROUTE_DIGI_DOCUMENT_SIGNER_CONFIGURATION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <DigiDocumentSignerConfiguration />
      </Suspense>
    ),
  },
  {
    path: ROUTE_ADD_DIGI_DOCUMENT_SIGNER_CONFIGURATION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <AddDigiDocumentSignerConfiguration />
      </Suspense>
    ),
  },
  {
    path: ROUTE_EDIT_DIGI_DOCUMENT_SIGNER_CONFIGURATION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EditDigiDocumentSignerConfiguration />
      </Suspense>
    ),
  },
  {
    path: ROUTE_VIEW_DIGI_DOCUMENT_SIGNER_CONFIGURATION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ViewDigiDocumentSignerConfiguration />
      </Suspense>
    ),
  },
];

export default DigiDocumentSignerConfigurationNavigation;
